export default "__VITE_ASSET__4DgzJf9r__"